export default __webpack_public_path__ + "static/media/RecreationalPaperVouchers.e488b07f.png";